import React from 'react';
import { useNetworkStatus } from '../contexts/NetworkStatusContext';

const NetworkStatusIndicator: React.FC = () => {
    const { isOnline } = useNetworkStatus();

    if (isOnline) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 99998,
            backgroundColor: '#DC6803',
            color: '#fff',
            textAlign: 'center',
            padding: '4px 0',
            fontSize: 12,
            fontWeight: 600,
            fontFamily: 'Inter, sans-serif',
        }}>
            Offline Mode — Changes will sync when connection is restored
        </div>
    );
};

export default NetworkStatusIndicator;
